import React from 'react';
import LoginComponent from '@/views/auth/login/Login.component';

export default function LoginModalView() {
  return (
    <div className='sm:w-96'>
      <LoginComponent />
    </div>
  );
}
